import * as React from 'react';
import { Component } from 'react';
import { getFormComponent } from './utils';

class ThreeColumnFormSection extends Component {
    constructor(props) {
        super(props);
    }    

    render() {
        const leftColumnCompmonents = (<div className="form-fields">
            {
                this.props.section.zones[0].formComponents.map((formComponent, key) => {
                    return getFormComponent(formComponent, this.props);
                })
            }
        </div>);
        const middleColumnCompmonents = (<div className="form-fields">
            {
                this.props.section.zones[1].formComponents.map((formComponent, key) => {
                    return getFormComponent(formComponent, this.props);
                })
            }
        </div>);
        const rightColumnCompmonents = (<div className="form-fields">
            {
                this.props.section.zones[2].formComponents.map((formComponent, key) => {
                    return getFormComponent(formComponent, this.props);
                })
            }
        </div>);
        return (
            <div style={this.props.visible && !this.props.posted ? {} : { display: 'none' }} className={this.props.isHighlighted ? "form-section highligted" : "form-section"}>
                <div className="row">
                    <div className="col-md-4">{leftColumnCompmonents}</div>
                    <div className="col-md-4">{middleColumnCompmonents}</div>
                    <div className="col-md-4">{rightColumnCompmonents}</div>
                </div>
            </div>
        )
    }
}

export default ThreeColumnFormSection;